import React, { useEffect, useState } from 'react'
import MaterialTable, { MTableToolbar } from 'material-table';
import _ from "lodash";
import SlidingPane from "react-sliding-pane";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import Select from 'react-select';
import DatePicker from "react-datepicker";

import { getTrans as t } from "../../../../Localization/translations";
import Helper from '../../../../Helper';
import { API } from '../../../../backend';
import authHeader from '../../../../services/auth-header';


const TaxCalculation = () => {

  const tableRef = React.createRef();

  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [selectedValue3, setSelectedValue3] = useState("");
  const [selectedValueenddate, setSelectedValueEndate] = useState("");

  const [selectedValue, setSelectedValue] = useState("");
  const [citytax, setCityTax] = useState("")
  const [countytax, setCountyTax] = useState("")
  const [transactiontype, setTransactionType] = useState("")
  const [transaction_No, setTransactionNo] = useState("")
  const [specialtax, setSpecialTax] = useState("")
  const [TaxState, setTaxState] = useState([]);
  const [selectedValue2, setSelectedValue2] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [selectedValue4, setSelectedValue4] = useState("");

  const handelChangebilling = (value) => {
    setSelectedValue3(value);
  };
  const handelChangeEnddate = (value) => {
    setSelectedValue4(value);
  };

  const handelSearch = () => {
    tableRef.current.onQueryChange();
  };

  const handleClear = () => {
    setSelectedValue("");
    setSelectedValue2("");
    setSelectedValue3("");
    setSelectedValueEndate('')
    setSelectedValue4("")
    setTransactionNo("")
    setTransactionType("")

    tableRef.current.onQueryChange();
  };

  // const range = {
  //   "Today": [moment(), moment()],
  //   "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
  //   "Last 7 Days": [moment().subtract(6, "days"), moment()],
  //   "Last 30 Days": [moment().subtract(29, "days"), moment()],
  //   "This Month": [moment().startOf("month"), moment().endOf("month")],
  //   "Last Month": [
  //     moment()
  //       .subtract(1, "month")
  //       .startOf("month"),
  //     moment()
  //       .subtract(1, "month")
  //       .endOf("month")
  //   ],
  //   "Last Year": [
  //     moment()
  //       .subtract(1, "year")
  //       .startOf("year"),
  //     moment()
  //       .subtract(1, "year")
  //       .endOf("year")
  //   ]
  // };

  // const handleEvent2 = (event, picker) => {
  //   setSelectedValue3(picker.startDate);
  //   setSelectedValueEndate(picker.endDate);
  // };

  // const clearDates = () => {
  //   setSelectedValue3('');
  //   setSelectedValueEndate('')
  // };

  useEffect(() => {
    // if (TaxCoutryId !== "") {
    const getstate = async () => {
      const resst = await fetch(API + "helper/ajax/load-states/" + 231 + "/");
      const getst = await resst.json();
      setTaxState(await getst);
    };
    getstate();
    // }
  }, []);

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setSelectedValue(getstateid);
  };
  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}contracts/contracts/filter/?id=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };
  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10; // Your page size

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };

      // Modify the logic here to handle customerName if needed
      let state_tax = "";
      let contractNumber = "";
      // let zip_code_name = "";
      let transaction_no = "";
      let transaction_type = ""
      let special_tax = ""

      if (selectedValue && specialtax && citytax && countytax) {
        state_tax = selectedValue;
        special_tax = specialtax;
        transaction_no = transaction_No;
      } else if (selectedValue2) {
        contractNumber = selectedValue2.contract_number
      } else if (specialtax) {
        special_tax = specialtax;
      } else if (transaction_No) {
        transaction_no = transaction_No;
      } else if (transactiontype) {
        transaction_type = transactiontype;
      }

      let url = API + "accounting/transactiontax-reports/?";
      url += "&per_page=" + query.pageSize;
      url += "&page=" + (query.page + 1);
      url += "&search=" + query.search;
      url += `&contract_number=${contractNumber !== "" ? contractNumber : ""}`;
      url += `&transaction_type=${transaction_type !== "" ? transaction_type : ''}`;
      url += `&transaction_no=${transaction_no !== "" ? transaction_no : ""}`;
      url += `&start_date=${selectedValue3 !== "" ? Helper.DatePicker(selectedValue3) : ""}`;
      url += `&end_date=${selectedValue4 !== "" ? Helper.DatePicker(selectedValue4) : ""}`;

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  return (
    <div className="page-wrapper">
      <div className="">
        {/* {loading === false ? ( */}
        <div className="row show_contract show_invoice">
          <div className="col-md-12">
            <div className=" mb-0">
              <div className="body">
                <div className="table-responsive p-0">
                  <MaterialTable
                    tableRef={tableRef}
                    style={{
                      backgroundColor: "var(--bs-table-bg)",
                      borderBottomWidth: "1px",
                      boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                    }}
                    title={<h5>{t("Tax Calculation Report")} </h5>}
                    columns={[
                      {
                        title: `${t("Contract No")}`,
                        field: "contract_number",
                        editable: "never",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Contract No")}
                            </div>
                            <div
                            // onClick={() => handleView(rowData.id)}
                            >
                              {rowData.contract_number ? rowData.contract_number : "None"}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Transaction")}`,
                        field: "invoice_header",
                        editable: "never",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Transaction")}
                            </div>
                            <div
                            // onClick={() => handleView(rowData.id)}
                            >
                              {rowData.invoice_header}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Transaction Type")}`,
                        field: "transaction_type",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Transaction Type")}
                            </div>
                            <div>{rowData.transaction_type}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Transaction Date")}`,
                        field: "transaction_date",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Transaction Type")}
                            </div>
                            <div>{rowData.transaction_date ? Helper.DateNormal(rowData.transaction_date) : "None"}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Taxable Amount")}`,
                        field: "taxable_amount",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Taxable Amount")}
                            </div>
                            <div>{Helper.Amount(rowData.taxable_amount)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("State Tax")}`,
                        field: "state_tax",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("State Tax")}
                            </div>
                            <div>{Helper.Amount(rowData.state_tax)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("County Tax")}`,
                        field: "county_tax",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("County Tax")}
                            </div>
                            <div>{Helper.Amount(rowData.county_tax)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("City Tax")}`,
                        field: "city_tax",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("City Tax")}
                            </div>
                            <div>{Helper.Amount(rowData.city_tax)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Special Tax")}`,
                        field: "special_tax",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Special Tax")}
                            </div>
                            <div>{Helper.Amount(rowData.special_tax)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Total Tax")}`,
                        field: "total_tax",
                        //   lookup: ENABLED,
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Total Tax")}
                            </div>
                            <div>{Helper.Amount(rowData.total_tax)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      // {
                      //   title: `${t("Tax Rate")}`,
                      //   field: "tax_rule_name",
                      //   //   lookup: ENABLED,
                      //   render: (rowData) => (
                      //     <>
                      //       <div className="d-xl-none tc d-md-none d-lg-none">
                      //         {t("Tax Rate")}
                      //       </div>
                      //       <div>
                      //         {rowData.tax_rule_name
                      //           ? (rowData.tax_rule_name)
                      //           : "None"}
                      //       </div>
                      //     </>
                      //   ),
                      //   headerStyle: {
                      //     verticalAlign: "inherit",
                      //     fontWeight: "bold",
                      //     textAlign: "left",
                      //   },
                      //   cellStyle: {
                      //     textAlign: "left",
                      //     fontSize: 12,
                      //   },
                      // },

                    ]}
                    data={
                      // permissionss && permissionsArray.includes('view_tax') === true ?
                      (query) =>
                        new Promise((resolve, reject) => {
                          const { orderBy, orderDirection } = query;
                          let state_tax = "";
                          let contractNumber = "";
                          // let zip_code_name = "";
                          let transaction_no = "";
                          let transaction_type = ""
                          let special_tax = ""

                          if (selectedValue && specialtax && citytax && countytax) {
                            state_tax = selectedValue;
                            special_tax = specialtax;
                            transaction_no = transaction_No;
                          } else if (selectedValue2) {
                            contractNumber = selectedValue2.contract_number
                          } else if (specialtax) {
                            special_tax = specialtax;
                          } else if (transaction_No) {
                            transaction_no = transaction_No;
                          } else if (transactiontype) {
                            transaction_type = transactiontype;
                          }

                          let url = API + "accounting/transactiontax-reports/?";
                          url += "&per_page=" + query.pageSize;
                          url += "&page=" + (query.page + 1);
                          url += "&search=" + query.search;
                          url += `&contract_number=${contractNumber !== "" ? contractNumber : ""}`;
                          url += `&transaction_type=${transaction_type !== "" ? transaction_type : ''}`;
                          url += `&transaction_no=${transaction_no !== "" ? transaction_no : ""}`;
                          url += `&start_date=${selectedValue3 !== "" ? Helper.DatePicker(selectedValue3) : ""}`;
                          url += `&end_date=${selectedValue4 !== "" ? Helper.DatePicker(selectedValue4) : ""}`;

                          // url += `&total_tax=${selectedValue3 !== "" ? Helper.DatePicker(selectedValue3) : ""}`;
                          if (orderBy) {
                            url += `&orderBy=${orderBy.field}`;
                            url += `&orderDirection=${orderDirection}`;
                          }
                          fetch(url, { headers: authHeader() })
                            .then((response) => response.json())
                            .then((result) => {
                              resolve({
                                data:
                                  query.orderBy && query.orderDirection
                                    ? _.orderBy(
                                      result.data,
                                      [query.orderBy.field],
                                      [query.orderDirection]
                                    )
                                    :
                                    result.data,
                                page: result.page - 1,
                                totalCount: result.total,
                              });
                            });
                        })
                      // : []
                    }
                    components={{
                      Toolbar: (props) => (
                        <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                          <MTableToolbar {...props} />
                          <span
                            onClick={() => setState({ isPaneOpen: true })}
                            style={{
                              color: "#b4b7c5",
                              paddingRight: "1px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/images/ic-filter.svg"
                              }
                              alt="filter"
                            />
                          </span>
                        </div>
                      ),
                      // Container: (props) => (
                      //   <div id="Payment">
                      //     <Paper {...props} />
                      //   </div>
                      // ),
                    }}
                    options={{
                      headerStyle: {
                        backgroundColor: "white",
                        color: "#245C7F",
                        fontSize: 12,
                      },
                      rowStyle: (rowData, index) => {
                        if (index % 2) {
                          return { backgroundColor: "#fff" };
                        }
                      },
                      sorting: true,
                      search: true,
                      toolbar: true,
                      paging: true,
                      pageSize: 10, // make initial page size
                      emptyRowsWhenPaging: false, // To avoid of having empty rows
                      pageSizeOptions: [10, 25, 50, 100],
                      paginationType: "stepped",
                      showFirstLastPageButtons: false,
                      exportAllData: true,
                      exportButton: true,
                      exportFileName: "Tax Calculation Reports",
                      actionsColumnIndex: -1,
                      columnsButton: true,
                      exportCsv: async (columns, data) => {
                        try {
                          const allData = await fetchAllDataForExport(); // Fetch all data

                          if (allData.length === 0) {
                            console.error("No data found for CSV export");
                            return;
                          }

                          const csvColumns = Helper.visibleColumn(columns); // Filter out hidden columns
                          const csvColumnTitles = csvColumns.map(column => column.title);

                          const title = "Taxcalculation Report";
                          const currentDate = new Date().toLocaleDateString();

                          let csvContentWithInfo = `${title}\n`;
                          if (selectedValue2) {
                            const selectedVal = selectedValue2.contract_number;
                            csvContentWithInfo += `Filter By contractNumber : ${selectedVal}\n`;
                          }else if (transaction_No) {
                            let transaction_no = "";
                            transaction_no = transaction_No;
                            csvContentWithInfo += `Filter By Transaction number : ${transaction_no}\n`;
                          }else if (transactiontype) {
                            let transaction_type = ""
                            transaction_type = transactiontype;
                            csvContentWithInfo += `Filter By Transaction Type : ${transaction_type}\n`;
                          }
                          
                          csvContentWithInfo += `Date: ${currentDate}\n\n`;

                          const csvData = allData.map(rowData =>
                            csvColumns.map(columnDef => {
                              return rowData[columnDef.field];
                            })
                          );

                          const csvRows = [csvColumnTitles, ...csvData];
                          const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`;

                          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                          const link = document.createElement('a');
                          link.href = URL.createObjectURL(blob);
                          link.download = 'Tax Calculation.csv';
                          link.style.display = 'none';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        } catch (error) {
                          console.error("Error exporting CSV:", error);
                        }
                      },
                      exportPdf: async (columns, data) => {
                        const allData = await fetchAllDataForExport(); // Fetch all data
                        if (allData.length === 0) {
                          console.error("No data found for PDF export");
                          return;
                        }

                        // Filter out hidden columns
                        const visibleColumns = Helper.visibleColumn(columns);

                        const doc = new jsPDF();
                        doc.setFont("helvetica", "bold");
                        doc.setFontSize(16);

                        const title = "Tax Calculation Report";
                        doc.text(title, 14, 10);

                        doc.setFontSize(12);
                        doc.setFont("helvetica", "normal");
                        const currentDate = new Date().toLocaleDateString();
                        doc.text(`Date : ${currentDate}`, 14, 15);
                        let selectedVal ;
                        let transactionno = transaction_No;
                        let transaction_type = transactiontype;
                        if (selectedValue2 && transaction_No && transactiontype) {
                          selectedVal =selectedValue2.contract_number;
                          transactionno = transaction_No;
                          transaction_type = transactiontype;
                            doc.text(`Filter By ContractNumber, Transaction number and Transaction Type : ${selectedVal === '' ? "" : selectedVal} , ${transactionno === '' ? "" : transactionno} and ${transaction_type === '' ? "" : transaction_type}`, 14, 20);
                        }
                        else if (selectedValue2) {
                          selectedVal =selectedValue2.contract_number;
                          doc.text(`Filter By ContractNumber : ${selectedVal} `, 14, 20);
                        }
                        else if (transaction_No) {
                          transactionno = transaction_No;
                          doc.text(`Filter By  Transaction number : ${transactionno}`, 14, 20);
                        }
                        else if (transactiontype) {
                          transaction_type = transactiontype;
                          doc.text(`Filter By Transaction Type : ${transaction_type}`, 14, 20);
                        }

                        const space = 22; 
                        const tableStartY = 5 + space;

                        const columnTitles = visibleColumns.map(columnDef => columnDef.title);
                        const pdfData = allData.map(rowData =>
                          visibleColumns.map(columnDef => {
                            return rowData[columnDef.field];
                          })
                        );
                        const tableData = [columnTitles, ...pdfData];

                        // doc.autoTable({
                        autoTable(doc,{
                          head: [tableData[0]], // Column headers
                          body: tableData.slice(1), // Data excluding headers
                          startY: tableStartY,// Set the starting y-coordinate for the table
                          columnStyles: visibleColumns // Apply column alignment styles

                        });

                        doc.save(`Tax Calculation.pdf`);
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={state1.isPaneOpen}
        title="Filter By"
        subtitle=""
        onRequestClose={() => {
          setState({ isPaneOpen: false });
        }}
      >
        <div className="col-xl-12">
          <div className="form-group row">
            {/* <label className="col-lg-12 col-form-label">{t("State")}</label>
            <div className="col-lg-12">
              <select
                name="state"
                className="form-control"
                onChange={handlestate}
                value={selectedValue}
              >
                <option value="">---Select State---</option>
                {TaxState.map((resst,i) => (
                  <option key={i} value={resst.name}>
                    {resst.name}
                  </option>
                ))}
              </select>
            </div> */}
            <label className="col-lg-12 col-form-label">{t("Contract No")}</label>
            <div className="">
              <Select
                value={selectedValue2}
                filterOption={false}
                options={options2}
                isClearable
                onInputChange={handleInputChangeData}
                getOptionLabel={(options) => options.contract_number}
                getOptionValue={(options) => options.contract_number}
                isLoading={isLoading2}
                placeholder={t("Search for Contract(%for All)")}
                onMenuScrollToBottom={handleMenuScrollToBottom}
                onChange={handelChange2}
              />
            </div>
            <label className="col-lg-12 col-form-label">{t("Transaction No")}</label>
            <div className="">
              <input
                className="form-control"
                placeholder="Transaction No"
                value={transaction_No}
                onChange={(e) => setTransactionNo(e.target.value)}
              />
            </div>
            <label className="col-lg-12 col-form-label">{t("Transaction Type")}</label>
            <div className="">
              <input
                className="form-control"
                placeholder="Transaction Type"
                value={transactiontype}
                onChange={(e) => setTransactionType(e.target.value)}
              />
            </div>
            <label className="col-lg-12 col-form-label">{t("Start Date")}</label>
            <div className="">
              <DatePicker
                className="form-control datepick"
                selected={selectedValue3}
                onChange={(e) => handelChangebilling(e)}
                placeholderText={"mm/dd/yyyy"}
                showYearDropdown // year show and scrolldown alos
                scrollableYearDropdown
                showMonthDropdown
                dropdownMode="select"
              />
            </div>
            <label className="col-lg-12 col-form-label">{t("End Date")}</label>
            <div className="">
              <DatePicker
                className="form-control datepick"
                selected={selectedValue4}
                onChange={(e) => handelChangeEnddate(e)}
                placeholderText={"mm/dd/yyyy"}
                showYearDropdown // year show and scrolldown alos
                scrollableYearDropdown
                showMonthDropdown
                dropdownMode="select"
              />
            </div>
            {/* <label className="col-lg-12 col-form-label">
              {t("Date")}
            </label>
            <div className="col-lg-12 position-relative">
              <DateRangePicker
                initialSettings={{ ranges: range }}
                startDate={selectedValue3 !== "" ? selectedValue3 : ""}
                endDate={selectedValueenddate !== "" ? selectedValueenddate : ""}
                alwaysShowCalendars={true}
                onEvent={handleEvent2}
              >
                <div className="form-control d-flex justify-content-between align-items-center">
                  <span>
                    {selectedValue3 !== '' ? Helper.DateNormal(selectedValue3) : "Select Start Date"} to {selectedValueenddate !== "" ? Helper.DateNormal(selectedValueenddate) : 'Select End Date'}
                  </span>

                </div>
              </DateRangePicker>
              {(selectedValue3 !== '' || selectedValueenddate !== "") && (
                <CloseIcon onClick={clearDates} style={{ position: 'absolute', top: '50%', right: '20px', transform: 'translateY(-50%)', cursor: 'pointer', height: '20px', width: '20px', color: '#b8b5b5' }} />
              )}
            </div> */}
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
              <button
                type="button"
                className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                onClick={handleClear}
              >
                {t("Reset")}
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="filter add btn btn-primary btn-m ms-auto mb-0"
                onClick={handelSearch}
              >
                {t("Apply")}
              </button>
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </SlidingPane>
    </div>)
}

export default TaxCalculation